/**
 * @generated SignedSource<<183615a0b3002f1a772bd61a83505350>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useInitializeLessonBookingWizardSession$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly firstName?: string | null | undefined;
      readonly fullName?: string;
      readonly id?: string;
      readonly lastName?: string | null | undefined;
      readonly membershipType: {
        readonly id: string;
      } | null | undefined;
      readonly profileImage?: {
        readonly publicId: string;
      } | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"useGetRequiredWizardSteps">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"useBookingPaymentCards_session">;
  readonly " $fragmentType": "useInitializeLessonBookingWizardSession";
};
export type useInitializeLessonBookingWizardSession$key = {
  readonly " $data"?: useInitializeLessonBookingWizardSession$data;
  readonly " $fragmentSpreads": FragmentRefs<"useInitializeLessonBookingWizardSession">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "profileImage",
  "plural": false,
  "selections": [
    {
      "alias": "publicId",
      "args": null,
      "kind": "ScalarField",
      "name": "renderingKey",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "currentDate"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useInitializeLessonBookingWizardSession",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "bookingDate",
          "variableName": "currentDate"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useBookingPaymentCards_session"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useGetRequiredWizardSteps"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "membershipType",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "fullName",
                  "storageKey": null
                },
                (v1/*: any*/),
                (v2/*: any*/),
                (v3/*: any*/)
              ],
              "type": "Member",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/),
                (v3/*: any*/)
              ],
              "type": "Customer",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};
})();

(node as any).hash = "e3f7d0c3f0c03ef4ca79e53b0c0f1541";

export default node;
